import { render, staticRenderFns } from "./headerComponent.vue?vue&type=template&id=af2e2ffa"
import script from "./headerComponent.vue?vue&type=script&lang=js"
export * from "./headerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports